import React, { useEffect } from "react";
import { InputNumber } from "primereact/inputnumber";
import { paymentStatus } from "../../utils/Function/Helper";
import "./OtherDetails.css";

function OtherDetails({
  formData,
  setFormData,
  errors,
  setErrors,
  photographerOption,
}) {
  const handleInputChange = (field, value) => {
    // Update formData
    setFormData({ ...formData, [field]: value });

    // Remove the specific error for the field if it exists
    if (errors[field]) {
      setErrors((prevErrors) => {
        const { [field]: _, ...rest } = prevErrors; // Exclude the specific error
        return rest; // Return the rest of the errors
      });
    }
  };

//setting payment status in form data
useEffect(()=>{
  setFormData((prevFormData) => ({ ...prevFormData, ['payment_status']: paymentStatus(formData.total_budget, formData.amount_paid) }));
}, [formData.total_budget, formData.amount_paid])

  return (
    <div className="form-section">
      <div className={`form-group ${errors.total_budget ? "error" : ""}`}>
        <label>Total Amount</label>
        <InputNumber
          maxLength={9}
          id="total_budget"
          value={formData.total_budget || ""}
          placeholder="Enter total budget"
          onValueChange={(e) => handleInputChange("total_budget", e.value)}
          required
          locale="en-IN"
        />
        {errors.total_budget && (
          <p className="error-message">{errors.total_budget}</p>
        )}
      </div>

      <div className={`form-group ${errors.amount_paid ? "error" : ""}`}>
        <label>Amount Paid</label>
        <InputNumber
          maxLength={9}
          id="amount_paid"
          value={formData.amount_paid || ""}
          placeholder="Enter Amount Paid"
          onValueChange={(e) => handleInputChange("amount_paid", e.value)}
          required
          locale="en-IN"
        />
        {errors.amount_paid && (
          <p className="error-message">{errors.amount_paid}</p>
        )}
      </div>

      <div className={`form-group ${errors.photographer_id ? "error" : ""}`}>
        <label>Photographer</label>
        <select
          value={formData.photographer_id || ""}
          onChange={(event) =>
            handleInputChange("photographer_id", event.target.value)
          }
        >
          <option value="" hidden>Select your Photographer</option>
          {Array.isArray(photographerOption) &&
          photographerOption.length > 0 ? (
            photographerOption.map((event) => (
              <option key={event.value} value={event.value}>
                {event.label}
              </option>
            ))
          ) : (
            <option value="" disabled>No available options</option>
          )}
        </select>
        {errors.photographer_id && (
          <p className="error-message">{errors.photographer_id}</p>
        )}
      </div>
    </div>
  );
}

export default OtherDetails;
